const luisValePedro = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/LuisValePedro.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/LuisValePedro.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Luis, Vale y Pedro',
  beds: 3,
  baths: 2,
  id: 'investor-1'
}

const luzYDiego = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Luz&Diego.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Luz&Diego.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Luz y Diego',
  beds: 2,
  baths: 2,
  id: 'investor-3'
}

const edgar = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Edgar.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Edgar.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Edgar',
  beds: 2,
  baths: 2,
  id: 'investor-4'
}

const paolaYZeus = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Paola&Zeus.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Paola&Zeus.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Paola y Zeus',
  beds: 1,
  baths: 1,
  id: 'investor-2'
}

const juliana = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Juliana.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Juliana.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Juliana',
  beds: 2,
  baths: 2,
  id: 'investor-5'
}

const marta = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Marta.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Marta.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Marta',
  beds: 2,
  baths: 2,
  id: 'investor-6'
}

const camilaYMora = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Camila&Mora.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Camila&Mora.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Camila y Mora',
  beds: 1,
  baths: 2,
  id: 'investor-2'
}

const mariaFernanda = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/MariaFernanda.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/MariaFernanda.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Maria Fernanda',
  beds: 2,
  baths: 2,
  id: 'investor-5'
}

const patricia = {
  image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Patricia.png?auto=compress,enhance,format&w=372&h=462&fit=crop',
  animated_image: 'https://assests-lahaus.imgix.net/static/images/hero-carousel/Patricia.gif?auto=compress,enhance,format&w=372&h=462&fit=crop',
  name: 'Patricia',
  beds: 2,
  baths: 2,
  id: 'investor-6'
}

export const INVESTORS_CAROUSEL = {
  co: [luisValePedro, paolaYZeus, luzYDiego, edgar, juliana, marta],
  mx: [luisValePedro, camilaYMora, luzYDiego, edgar, mariaFernanda, patricia]
}
